import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import {
	CHECK_GLOBAL_ISSUE_CREATE,
	type CheckGlobalIssueCreateAction,
} from '../../state/actions/app/index.tsx';
import {
	type CardCreateGlobalAction,
	type CardCreateUnmappedWithIssueLinkAction,
	cardCreateGlobal,
	cardCreateUnmappedWithIssueLink,
} from '../../state/actions/cards/create/index.tsx';
import { type RefetchVersionsAction, refetchVersions } from '../../state/actions/version/index.tsx';
import { getColumnStatusIds } from '../../state/selectors/statuses/index.tsx';
import type { ActionsObservable, MiddlewareAPI } from '../../state/types.tsx';

export const checkGlobalIssueCreateEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(CHECK_GLOBAL_ISSUE_CREATE).mergeMap((action: CheckGlobalIssueCreateAction) => {
		const {
			payload: { issues: globalIssues },
		} = action;

		if (globalIssues.length === 0) {
			return Observable.empty<never>();
		}

		const state = store.getState();
		const actions: Array<
			CardCreateGlobalAction | CardCreateUnmappedWithIssueLinkAction | RefetchVersionsAction
		> = [];

		// We should refetch versions data when an issue is created to keep the version panel on sync
		// and to avoid this issue: https://hello.atlassian.net/browse/FEBA-1548a
		actions.push(refetchVersions());

		// Check if any globally created issues have unmapped statuses
		// (this doesn't however apply to epics since they will be visible on the backlog and board)
		const columnStatusIds = getColumnStatusIds(state);
		const unmappedIssuesExist = globalIssues
			.filter(
				(issue) =>
					issue.createdIssueDetails &&
					issue.createdIssueDetails.fields.issuetype.hierarchyLevel < 1,
			)
			.some(
				(issue) =>
					issue.createdIssueDetails &&
					!columnStatusIds.includes(issue.createdIssueDetails.fields.status.id),
			);
		if (unmappedIssuesExist) {
			const cardsIdentifiers = globalIssues.map((issue) => ({
				id: Number(issue.issueId),
				key: issue.issueKey,
			}));
			actions.push(cardCreateUnmappedWithIssueLink(cardsIdentifiers));
		} else {
			actions.push(cardCreateGlobal(globalIssues));
		}

		return Observable.from(actions);
	});
